import * as actions from "./actions";

import _ from "underscore";
import update from "immutability-helper";

import moment from "moment";

let initialState = {
  applications: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
    rebuild: {
      sending: false,
      sent: false,
      error: null,
    },
  },

  creditApplications: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
    rebuild: {
      sending: false,
      sent: false,
      error: null,
    },
  },

  reviewingCreditApplications: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 5 },
    },
    data: [],
  },

  reviewingApplications: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 5 },
    },
    data: [],
  },

  preApplications: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  approve: {
    approved: false,
    error: null,
  },

  reject: {
    rejected: false,
    error: null,
  },

  kreditzReport: {
    result: null,
    fetching: false,
    error: null,
  },
};

const applications = (state = initialState, action) => {
  switch (action.type) {
    // GET APPLICATIONS
    case actions.APPLICATION_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          fetching: true,
          fetchError: null,
          data: action.additionalData.preventClearOnLoading
            ? state.applications.data
            : [],
        }),
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });

    case actions.APPLICATION_LIST_GET_SUCCESS: {
      let data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      let applications = data
        .filter((a) => {
          return a.Stage == "AwaitingManualReview";
        })
        .sort((a, b) => {
          return a.DateSubmitted - b.DateSubmitted;
        });

      let applicationsOnHold = data
        .filter((a) => {
          return a.Stage == "OnHold";
        })
        .sort((a, b) => {
          return a.DateSubmitted - b.DateSubmitted;
        });

      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          fetching: false,
          fetched: true,
          data: applications,
        }),
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          fetching: false,
          fetched: true,
          data: applicationsOnHold,
        }),
      });
    }

    case actions.APPLICATION_LIST_GET_ERROR:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.CREDIT_APPLICATION_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        creditApplications: Object.assign({}, state.creditApplications, {
          fetching: true,
          fetchError: null,
          data: action.additionalData.preventClearOnLoading
            ? state.creditApplications.data
            : [],
        }),
        reviewingCreditApplications: Object.assign(
          {},
          state.reviewingCreditApplications,
          {
            fetching: true,
            fetchError: null,
            data: [],
          },
        ),
      });

    case actions.CREDIT_APPLICATION_LIST_GET_SUCCESS: {
      let data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      const applications = data
        .filter((a) => {
          return a.OnHold === false;
        })
        .sort((a, b) => {
          return a.UserInfoFinalizedAt - b.UserInfoFinalizedAt;
        });

      const applicationsOnHold = data
        .filter((a) => {
          return a.OnHold === true;
        })
        .sort((a, b) => {
          return a.UserInfoFinalizedAt - b.UserInfoFinalizedAt;
        });

      return Object.assign({}, state, {
        creditApplications: Object.assign({}, state.creditApplications, {
          fetching: false,
          fetched: true,
          data: filter_app_warnings(applications),
        }),
        reviewingCreditApplications: Object.assign(
          {},
          state.reviewingCreditApplications,
          {
            fetching: false,
            fetched: true,
            data: filter_app_warnings(applicationsOnHold),
          },
        ),
      });
    }

    case actions.CREDIT_APPLICATION_LIST_GET_ERROR:
      return Object.assign({}, state, {
        creditApplications: Object.assign({}, state.applications, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.PRE_APPLICATION_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        preApplications: Object.assign({}, state.applications, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });

    case actions.PRE_APPLICATION_LIST_GET_SUCCESS: {
      //ToDo: remove swapData when termination from backend is ready
      //for now it will swap the filtered data with all data
      return Object.assign({}, state, {
        preApplications: Object.assign({}, state.preApplications, {
          fetching: false,
          fetched: true,
          data: Array.isArray(action.response)
            ? action.response
            : [action.response],
        }),
      });
    }

    case actions.PRE_APPLICATION_LIST_GET_ERROR:
      return Object.assign({}, state, {
        preApplications: Object.assign({}, state.applications, {
          fetching: false,
          error: action.error,
        }),
      });

    // GET APPLICATIONS UNDER REVIEW
    case actions.APPLICATION_UNDER_REVIEW_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });

    case actions.APPLICATION_UNDER_REVIEW_LIST_GET_SUCCESS: {
      let data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      let datenow = moment(new Date()).subtract(30, "days");
      let allData = data;

      data = _.filter(data, (value) => {
        return moment(value.DateSubmitted).isAfter(datenow);
      });

      data = data.sort((a, b) => {
        return a.DateSubmitted - b.DateSubmitted;
      });

      //ToDo: remove swapData when termination from backend is ready
      //for now it will swap the filtered data with all data
      return Object.assign({}, state, {
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          fetching: false,
          fetched: true,
          data,
          swapData: allData,
        }),
      });
    }

    case actions.APPLICATION_UNDER_REVIEW_LIST_GET_ERROR:
      return Object.assign({}, state, {
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          fetching: false,
          error: action.error,
        }),
      });
    case actions.TRANSFER_TO_REVIEW_SUCCESS: {
      let sentId = action.dataSent.ApplicationId;
      let applicationList = state.applications.data.slice();
      let applicationReviewdList = state.reviewingApplications.data.slice();

      let toChangeIndex = _.findIndex(state.applications.data, (item) => {
        return item.Id === sentId;
      });

      let appArray = applicationList.splice(toChangeIndex, 1); // returns list

      if (appArray.length === 1) {
        let app = appArray[0];
        app.Stage = "OnHold";
        applicationReviewdList.push(app);
      }

      return Object.assign({}, state, {
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          data: applicationReviewdList,
        }),
        applications: Object.assign({}, state.applications, {
          data: applicationList,
        }),
      });
    }

    ///////////////////////
    /////////
    case actions.SWAP_APPLICATION_DATA: {
      let data = state.applications.data;
      let swapData = state.applications.swapData;

      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          data: swapData,
          swapData: data,
        }),
      });
    }

    //////////////////
    ///////// table actions applications
    case actions.APPLICATION_ON_HOLD_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          table: Object.assign({}, state.reviewingApplications.table, {
            pagination: Object.assign(
              {},
              state.reviewingApplications.table.pagination,
              {
                page: action.page,
              },
            ),
          }),
        }),
      });

    case actions.APPLICATION_ON_HOLD_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        reviewingApplications: Object.assign({}, state.reviewingApplications, {
          table: Object.assign({}, state.reviewingApplications.table, {
            currentFilter: Object.assign(
              {},
              state.reviewingApplications.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });

    //////////////////
    ///////// table actions applications
    case actions.PRE_APPLICATION_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        preApplications: Object.assign({}, state.preApplications, {
          table: Object.assign({}, state.preApplications.table, {
            pagination: Object.assign(
              {},
              state.preApplications.table.pagination,
              {
                page: action.page,
              },
            ),
          }),
        }),
      });

    case actions.PRE_APPLICATION_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        preApplications: Object.assign({}, state.preApplications, {
          table: Object.assign({}, state.preApplications.table, {
            currentFilter: Object.assign(
              {},
              state.preApplications.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });

    //////////////////
    ///////// table actions reviewing
    case actions.APPLICATION_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          table: Object.assign({}, state.applications.table, {
            pagination: Object.assign({}, state.applications.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });

    case actions.APPLICATION_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          table: Object.assign({}, state.applications.table, {
            currentFilter: Object.assign(
              {},
              state.applications.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });

    // APPROVE APPLICATION
    case actions.APPLICATION_APPROVE_SUCCESS: {
      let id = action.dataSent.ApplicationId;
      let toChangeIndex = _.findIndex(state.applications.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex === -1) {
        toChangeIndex = _.findIndex(
          state.reviewingApplications.data,
          (item) => {
            return item.Id === id;
          },
        );
        return Object.assign({}, state, {
          approve: Object.assign({}, state.approve, {
            approved: true,
            error: null,
          }),
          reviewingApplications: Object.assign(
            {},
            state.reviewingApplications,
            {
              data: [
                ...state.reviewingApplications.data.slice(0, toChangeIndex),
                ...state.reviewingApplications.data.slice(toChangeIndex + 1),
              ],
            },
          ),
        });
      } else {
        return Object.assign({}, state, {
          approve: Object.assign({}, state.approve, {
            approved: true,
            error: null,
          }),
          applications: Object.assign({}, state.applications, {
            data: [
              ...state.applications.data.slice(0, toChangeIndex),
              ...state.applications.data.slice(toChangeIndex + 1),
            ],
          }),
        });
      }
    }

    case actions.APPLICATION_APPROVE_ERROR:
      return Object.assign({}, state, {
        approve: Object.assign({}, state.approve, {
          approved: false,
          error: action.error,
        }),
      });

    // REJECT APPLICATION
    case actions.APPLICATION_REJECT_SUCCESS: {
      let id = action.dataSent.ApplicationId;
      let toChangeIndex = _.findIndex(state.applications.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex === -1) {
        toChangeIndex = _.findIndex(
          state.reviewingApplications.data,
          (item) => {
            return item.Id === id;
          },
        );

        return Object.assign({}, state, {
          reject: Object.assign({}, state.reject, {
            rejected: true,
            error: null,
          }),
          reviewingApplications: Object.assign(
            {},
            state.reviewingApplications,
            {
              data: [
                ...state.reviewingApplications.data.slice(0, toChangeIndex),
                ...state.reviewingApplications.data.slice(toChangeIndex + 1),
              ],
            },
          ),
        });
      } else {
        return Object.assign({}, state, {
          reject: Object.assign({}, state.reject, {
            rejected: true,
            error: null,
          }),
          applications: Object.assign({}, state.applications, {
            data: [
              ...state.applications.data.slice(0, toChangeIndex),
              ...state.applications.data.slice(toChangeIndex + 1),
            ],
          }),
        });
      }
    }
    case actions.CREDIT_APPLICATION_APPROVE_SUCCESS:
    case actions.CREDIT_APPLICATION_REJECT_SUCCESS:
    case actions.APPROVE_REJECT_THRESHOLD_SUCCESS: {
      let id = action.dataSent.ApplicationId;
      let toChangeIndex = _.findIndex(state.creditApplications.data, (item) => {
        return item.Id === id;
      });

      if (toChangeIndex === -1) {
        toChangeIndex = _.findIndex(
          state.reviewingCreditApplications.data,
          (item) => {
            return item.Id === id;
          },
        );

        return Object.assign({}, state, {
          reviewingCreditApplications: Object.assign(
            {},
            state.reviewingCreditApplications,
            {
              data: [
                ...state.reviewingCreditApplications.data.slice(
                  0,
                  toChangeIndex,
                ),
                ...state.reviewingCreditApplications.data.slice(
                  toChangeIndex + 1,
                ),
              ],
            },
          ),
        });
      } else {
        return Object.assign({}, state, {
          creditApplications: Object.assign({}, state.creditApplications, {
            data: [
              ...state.creditApplications.data.slice(0, toChangeIndex),
              ...state.creditApplications.data.slice(toChangeIndex + 1),
            ],
          }),
        });
      }
    }

    case actions.APPLICATION_REJECT_ERROR:
      return Object.assign({}, state, {
        reject: Object.assign({}, state.reject, {
          rejected: false,
          error: action.error,
        }),
      });

    /* additional data for application */
    case actions.EXPANDED_DATA_BISNODE_REQUEST: {
      /// it can be that more that one app ist for the same user so more than one index needs to change
      let current_users_indexes = get_all_indexes(
        state.applications.data,
        action.correlation.Id,
      );
      let applications = state.applications.data.slice();

      for (let i = 0; i < current_users_indexes.length; i++) {
        let current_item_index = current_users_indexes[i];
        applications[current_item_index].newDataLoading = true;
      }

      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          data: applications,
        }),
      });
    }

    case actions.EXPANDED_DATA_BISNODE_SUCCESS: {
      let current_users_indexes = get_all_indexes(
        state.applications.data,
        action.correlation.Id,
      );
      let applications = state.applications.data.slice();

      for (let i = 0; i < current_users_indexes.length; i++) {
        let current_item_index = current_users_indexes[i];
        applications[current_item_index].bisnodeData = action.response;
      }
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          data: applications,
        }),
      });
    }

    // Rebuild functionality
    case actions.REBUILD_PENDING_APPLICATIONS_REQUEST: {
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          rebuild: Object.assign({}, state.applications.rebuild, {
            sending: true,
          }),
        }),
      });
    }

    case actions.REBUILD_PENDING_APPLICATIONS_SUCCESS: {
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          rebuild: Object.assign({}, state.applications.rebuild, {
            sending: false,
            sent: true,
            error: null,
          }),
        }),
      });
    }

    case actions.REBUILD_PENDING_APPLICATIONS_ERROR: {
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          rebuild: Object.assign({}, state.applications.rebuild, {
            sending: false,
            error: action.error,
          }),
        }),
      });
    }

    case actions.AUTO_REVIEW_FETCH_SUCCESS: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.additionalData.applicationId,
      );

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              AutoReviews: { $push: [action.response] },
            },
          },
        },
      });
    }

    case actions.CREATE_KREDITZ_REVIEW_POST_REQUEST: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex === -1) return state;

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: true },
            },
          },
        },
      });
    }

    case actions.CREATE_KREDITZ_REVIEW_CREDIT_POST_REQUEST: {
      const apps = state.creditApplications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex === -1) return state;

      return update(state, {
        creditApplications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: true },
            },
          },
        },
      });
    }

    case actions.CREATE_KREDITZ_REVIEW_CREDIT_POST_SUCCESS: {
      const apps = state.creditApplications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex === -1) return state;

      return update(state, {
        creditApplications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: false },
            },
          },
        },
      });
    }

    case actions.CREATE_KREDITZ_REVIEW_POST_ERROR: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex === -1) return state;

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: false },
              kreditzError: { $set: action.error },
            },
          },
        },
      });
    }

    case actions.CREATE_KREDITZ_REVIEW_POST_SUCCESS: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex == -1) return state;

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: false },
            },
          },
        },
      });
    }

    case actions.GET_KREDITZ_REPORT_GET_REQUEST: {
      return update(state, {
        kreditzReport: {
          result: { $set: null },
          fetching: { $set: true },
        },
      });
    }

    case actions.GET_KREDITZ_REPORT_GET_SUCCESS: {
      return update(state, {
        kreditzReport: {
          result: { $set: action.response },
          fetching: { $set: false },
        },
      });
    }

    case actions.GET_KREDITZ_REPORT_GET_ERROR: {
      return update(state, {
        kreditzReport: {
          result: { $set: null },
          fetching: { $set: false },
          error: { $set: action.error },
        },
      });
    }

    case actions.CREATE_CREDITSAFE_REPORT_REQUEST: {
      const apps = state.creditApplications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex === -1) return state;

      return update(state, {
        creditApplications: {
          data: {
            [applicationToUpdateIndex]: {
              createCreditsafePending: { $set: true },
            },
          },
        },
      });
    }

    case actions.CREATE_CREDITSAFE_REPORT_SUCCESS:
    case actions.CREATE_CREDITSAFE_REPORT_ERROR: {
      const apps = state.creditApplications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex === -1) return state;

      return update(state, {
        creditApplications: {
          data: {
            [applicationToUpdateIndex]: {
              createCreditsafePending: { $set: false },
            },
          },
        },
      });
    }

    default:
      return state;
  }
};

function get_all_indexes(array, id, searchKey = "Id") {
  let indexes = [];
  for (let index = 0; index < array.length; index++) {
    let element = array[index];
    if (element[searchKey] === id) {
      indexes.push(index);
    }
  }
  return indexes;
}

function filter_app_warnings(applications) {
  return applications.map((app) => {
    let _bgColor = null;
    const amlWarnings = app.AmlWarnings.filter(
      (w) => w.CurrentStatus !== "Declined",
    );
    const fraudWarnings = app.FraudWarnings;

    if (amlWarnings.length) _bgColor = "red";
    else if (fraudWarnings.length) _bgColor = "orange";

    return {
      ...app,
      AmlWarnings: amlWarnings,
      disabled: amlWarnings.length,
      bgColor: _bgColor,
    };
  });
}

export default applications;
